import { useMutation } from '@tanstack/react-query';
import {
  createEpic,
  createTask,
  deleteTask,
  editTask,
  getEpic,
  getMovie,
  getEpicUserstories,
  qcDone,
  updateEpicSubtitle,
} from '../requests/epic';
import { Epic, GetEpicRequest } from '../types/epic';

export const useGetEpic = () => useMutation<Epic, unknown, GetEpicRequest, unknown>(getEpic);

export const useGetEpicUserstories = () => useMutation(getEpicUserstories);

export const useUpdateEpicSubtitle = () => useMutation(updateEpicSubtitle);

export const useCreateTask = () => useMutation(createTask);

export const useDeleteTask = () => useMutation(deleteTask);

export const useEditTask = () => useMutation(editTask);

export const useCreateEpic = () => useMutation(createEpic);

export const useQCDone = () => useMutation(qcDone);

export const useGetMovie = () => useMutation(getMovie);
